import { RATE_PER_SPACE_SIZE_UNIT } from '../commission_modes';
import { getCommissionAmount, updateLeaseTerm } from './lease_term';

export function getLeaseStructureAggregates(leaseStructure) {
  const { commissionMode, commissionRate, leaseTerms, spaceSize } = leaseStructure;

  let buySideCommissionAmount = 0;
  let commissionAmount = 0;
  let leaseAmount = 0;
  let months = 0;
  let sellSideCommissionAmount = 0;
  let startDate = null;
  let lastLeaseTerm = null;

  for (const leaseTerm of leaseTerms) {
    if (leaseTerm._destroy) {
      continue;
    }

    startDate = startDate || leaseTerm.startDate;

    if (leaseTerm.commissionAmount) {
      commissionAmount += leaseTerm.commissionAmount;
      if (leaseTerm.transactionSideDetails?.length) {
        buySideCommissionAmount += getCommissionAmount(leaseTerm, 'buy_side');
        sellSideCommissionAmount += getCommissionAmount(leaseTerm, 'sell_side');
      }
    }

    if (leaseTerm.leaseAmount) {
      leaseAmount += leaseTerm.leaseAmount;
    }

    if (leaseTerm.months) {
      months += leaseTerm.months;
    }

    lastLeaseTerm = leaseTerm;
  }

  let endDate = null;
  if (lastLeaseTerm) {
    endDate = lastLeaseTerm.endDate;
  }

  if (commissionMode === RATE_PER_SPACE_SIZE_UNIT) {
    if (commissionRate != null && spaceSize != null) {
      commissionAmount = commissionRate * spaceSize;
    } else {
      commissionAmount = 0;
    }
  }

  return {
    buySideCommissionAmount,
    buySideCommissionPercent: leaseAmount === 0 ? null : buySideCommissionAmount / leaseAmount * 100.0,
    commissionAmount,
    commissionPercent: leaseAmount === 0 ? null : commissionAmount / leaseAmount * 100.0,
    endDate,
    leaseAmount,
    months,
    sellSideCommissionAmount,
    sellSideCommissionPercent: leaseAmount === 0 ? null : sellSideCommissionAmount / leaseAmount * 100.0,
    startDate
  };
}

export function updateLeaseStructure(leaseStructure) {
  return {
    ...leaseStructure,
    leaseTerms: leaseStructure.leaseTerms.map((leaseTerm) => {
      // A change to units or space size will affect only lease rate and values derived from it
      return updateLeaseTerm(leaseStructure, { ...leaseTerm }, 'leaseRate');
    })
  };
}

export function countRealTerms(leaseStructure) {
  return leaseStructure.leaseTerms.filter(term => !term._destroy).length;
}